// extracted by mini-css-extract-plugin
export var actionButton = "_ki-0";
export var fileInput = "_ki-2";
export var paperclip = "_ki-1";